import JSDB, {ApiCall, NKTypeConvertor} from '../../fromKotlin/nk';
import {badPhoto, base64ToArrayBuffer, byteArrayToImg, dateObjectToString, printPdf, saveByteArray} from '../../fromKotlin/nkutils';
import {DocumentType} from '../../types/DocumentsTypes/Document';
import {documentTypes} from '../../types/DocumentsTypes/utils';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {sendPdfEmail} from './documents.api';

export const dataToAccountent: (fromDate: Date, toDate: Date, hashavshevet?: boolean) => Promise<any> = async (fromDate, toDate, hashavshevet = false) => {
    const req: ApiCall = new ApiCall('DATA_TO_ACCOUNT_MANAGER');
    req.putParam('date_range', `${dateObjectToString(fromDate)}..${dateObjectToString(toDate)}`);
    req.putParam('hashavshevet', hashavshevet);
    if(hashavshevet)
        req.putParam('forceType',0);

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return (result.first)!;
};

export const dataToHash: (fromDate: Date, toDate: Date,ids?: number[],doc_types?:number[],hashavshevet?:boolean) => Promise<any> = async (fromDate, toDate,ids,doc_types,hashavshevet) => {
    const req: ApiCall = new ApiCall('CALCULATE_API_HASHAVSHEVET_zip');
    req.putParam('date_start', dateObjectToString(fromDate));
    req.putParam('date_end', dateObjectToString(toDate));
    req.putParam('ids', NKTypeConvertor().toKotlinList(ids));
    req.putParam('types', NKTypeConvertor().toKotlinList(doc_types));
    if(hashavshevet)
        req.putParam('forceType',0);
    console.log(req)
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return (result.first)!;
};

export type HashavshevetCheckpoints = {
    last_invoice_id: number;
    last_refund_id: number;
    last_invoice_payment_id: number;
    last_receipt_id: number;
    last_deposit_id: number;
};

export const getHashavshevetCheckpoints = async (): Promise<HashavshevetCheckpoints> => {
    const result = await new ApiCall('GET_HASHAVSHEVET_CONFIG').execute();
    if (result == null || result.second.name !== 'SUCCESS' || result.first == null)
        throw new Error('Could not load Hashavshevet checkpoints');
    return {
        last_invoice_id: Number(result.first.last_invoice_id ?? 0),
        last_refund_id: Number(result.first.last_refund_id ?? 0),
        last_invoice_payment_id: Number(result.first.last_invoice_payment_id ?? 0),
        last_receipt_id: Number(result.first.last_receipt_id ?? 0),
        last_deposit_id: Number(result.first.last_deposit_id ?? 0),
    };
};

export const dataToHashFromCheckpoints = async (
    checkpoints: Partial<HashavshevetCheckpoints>
): Promise<any> => {
    const req = new ApiCall('CALCULATE_API_HASHAVSHEVET_zip');
    const today = dateObjectToString(new Date());
    // The calculation API still carries its legacy date arguments, but checkpoint mode
    // resolves documents exclusively from the selected IDs on the server.
    req.putParam('date_start', today);
    req.putParam('date_end', today);
    Object.entries(checkpoints).forEach(([name, value]) => {
        if (value !== undefined && value !== null) {
            req.putParam(name, Math.max(0, Number(value)));
        }
    });
    const result = await req.execute();
    if (result == null || result.second.name !== 'SUCCESS')
        throw new Error('Could not generate Hashavshevet export');
    return result.first;
};

export const edi100: (id) => Promise<any> = async (id) => {
    const req: ApiCall = new ApiCall('EDI_100_CALC');
    req.putParam('tax_id',Number(id));
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return (result.first)!;
};

export const bkmvdata: (from,to,no_cancel) => Promise<any> = async (from,to,no_cancel) => {
    const req: ApiCall = new ApiCall('BKMVDATA_CALC');
    req.putParam('fromDate', dateObjectToString(from));
    req.putParam('toDate', dateObjectToString(to));
    if(no_cancel){
        req.putParam('no_cancel',no_cancel);
    }
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return (result.first)!;
};

export const pcn874: (from: Date, to: Date, no_cancel?: boolean, reportMonth?: string) => Promise<any> = async (from, to, no_cancel, reportMonth) => {
    const req: ApiCall = new ApiCall('PCN874_CALC');
    req.putParam('fromDate', dateObjectToString(from));
    req.putParam('toDate', dateObjectToString(to));
    if (no_cancel) {
        req.putParam('no_cancel', no_cancel);
    }
    if (reportMonth) {
        req.putParam('reportMonth', reportMonth);
    }
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return (result.first)!;
};

export const getReportPdf: (fromDate: Date, toDate: Date, reportType: string, category?: string, reportParam?: string) => Promise<any> = async (fromDate, toDate, reportType, category, reportParam) => {
    const req: ApiCall = new ApiCall('CALCULATE_CLIENT_REPORT_PDF');

    req.putParam('fromDate', dateObjectToString(fromDate));
    req.putParam('toDate', dateObjectToString(toDate));
    req.putParam('report_type', reportType);
    if (category != null && category !== '')
        req.putParam('category', category);
    if (reportParam != null && reportParam !== '')
        req.putParam('param', reportParam);
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return result.first;

};

export const getReportPdfExtended: (fromDate: Date, toDate: Date, reportType: string, agent?: string, minValue?: number) => Promise<any> = async (fromDate, toDate, reportType, agent, minValue) => {
    const req: ApiCall = new ApiCall('CALCULATE_CLIENT_REPORT_PDF');

    req.putParam('fromDate', dateObjectToString(fromDate));
    req.putParam('toDate', dateObjectToString(toDate));
    req.putParam('report_type', reportType);
    if (agent != null && agent !== '')
        req.putParam('param', agent.toString());
    if (minValue != null)
        req.putParam('param', (minValue).toString());
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return result.first;

};

export const getCategoryReport: (fromDate: Date, toDate: Date,  category?: string) => Promise<any> = async (fromDate, toDate, category) => {
    const req: ApiCall = new ApiCall('CLIENT_CATEGORY_SUM');

    req.putParam('date_range', `${dateObjectToString(fromDate)}..${ dateObjectToString(toDate)}`);
    if (category != null && category !== '')
        req.putParam('category', category);
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return result.first;

};
export const sendMsgAll: (ids: number[], msg: string, title: string, doc_types?: number[], emails?: string[], phones?: string[], action_date?: Date,special_arg?:string,external_var?:string[],unique_id?:number) => Promise<any> = async (ids, msg, title, doc_types, emails, phones, action_date,special_arg,external_var,unique_id) => {
    const req: ApiCall = new ApiCall('SEND_MSG_ALL');

    if (action_date)
        req.putParam('action_date', dateObjectToString(action_date));
    req.putParam('ids', NKTypeConvertor().toKotlinList(ids));
    req.putParam('msg', msg);

    req.putParam('title', title);
    if (doc_types)
        req.putParam('doc_type', NKTypeConvertor().toKotlinList(doc_types));
    if (emails)
        req.putParam('emails', NKTypeConvertor().toKotlinList(emails));
    if (phones)
        req.putParam('phones', NKTypeConvertor().toKotlinList(phones));
    if (special_arg)
        req.putParam('special_arg', special_arg);
    if (external_var)
        req.putParam('external_var', NKTypeConvertor().toKotlinList(external_var));
    if(unique_id)
        req.putParam('unique_id', unique_id);

    req.putParam('agent', JSDB().currentAgent);
    const result = await req.execute();

    if (result == null || result.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return result;

};
export const dataMimshak: (fromDate: Date, toDate: Date, method?: string, c_ids?: number[], ids?: number[]) => Promise<any> = async (fromDate, toDate, method, c_ids, ids) => {
    const req: ApiCall = new ApiCall('CALCULATE_API_EXCEL_zip');
    if (method)
        req.putParam('xlsxType', method);
    req.putParam('date_start', dateObjectToString(fromDate));
    req.putParam('date_end', dateObjectToString(toDate));
    if (c_ids)
        req.putParam('c_ids', NKTypeConvertor().toKotlinList(c_ids));
    if (ids)
        req.putParam('ids', NKTypeConvertor().toKotlinList(ids));
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return (result.first)!;
};

export const pricesPdf: (id: number, fromDate: Date, p_ids?: number[], priceCols?: string) => Promise<any> = async (id, fromDate, p_ids, priceCols) => {
    const req: ApiCall = new ApiCall('GET_CLIENT_PRICES_PDF');

    req.putParam('id', id);
    req.putParam('date', dateObjectToString(fromDate));
    if (p_ids)
        req.putParam('p_ids', NKTypeConvertor().toKotlinList(p_ids));
    if (priceCols != null)
        req.putParam('price_cols', priceCols);
    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return (result.first)!;
};

const LOGO_JPEG_QUALITY = 0.95;

const looksLikeLogoBytes = (bytes: any): boolean => {
    if (bytes == null || typeof bytes.length !== 'number' || bytes.length < 4) return false;
    const a = bytes[0] & 0xFF;
    const b = bytes[1] & 0xFF;
    return (a === 0xFF && b === 0xD8) || (a === 0x89 && b === 0x50);
};

/** Convert any raster image to JPEG at the original pixel size. */
export const imageFileToJpegDataUrl = async (file: File, quality = LOGO_JPEG_QUALITY): Promise<string> => {
    const draw = (width: number, height: number, paint: (ctx: CanvasRenderingContext2D) => void) => {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('canvas');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, width, height);
        paint(ctx);
        return canvas.toDataURL('image/jpeg', quality);
    };
    try {
        const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' } as ImageBitmapOptions);
        try {
            return draw(bitmap.width, bitmap.height, (ctx) => ctx.drawImage(bitmap, 0, 0));
        } finally {
            bitmap.close();
        }
    } catch {
        const objectUrl = URL.createObjectURL(file);
        try {
            const img = await new Promise<HTMLImageElement>((resolve, reject) => {
                const el = new Image();
                el.onload = () => resolve(el);
                el.onerror = () => reject(new Error('invalid image'));
                el.src = objectUrl;
            });
            return draw(img.naturalWidth, img.naturalHeight, (ctx) => ctx.drawImage(img, 0, 0));
        } finally {
            URL.revokeObjectURL(objectUrl);
        }
    }
};

const logoBytesToDataUrl = (bytes: any): string | null => {
    if (!looksLikeLogoBytes(bytes)) return null;
    const dataUrl = byteArrayToImg(bytes);
    if (!dataUrl || dataUrl === badPhoto) return null;
    return dataUrl;
};

export const fetchLogo: () => Promise<string | null> = async () => {
    const req: ApiCall = new ApiCall('LOGO');
    const result = await req.execute();
    return logoBytesToDataUrl(result?.first);
};

export const uploadLogo: (logo: string) => Promise<any> = async (logo) => {
    const req: ApiCall = new ApiCall('UPLOAD_LOGO');
    const img = base64ToArrayBuffer(logo);
    req.putParam('image', img);

    const result = await req.execute();

    if (result == null || result.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    return true;
};

export const updateCofcConf: (with_price?: number,time_close?:string,lock?:number) => Promise<any> = async (with_price, time_close, lock) => {
    const req: ApiCall = new ApiCall('UPDATE_COFC_CONF');

    if (with_price != null)
        req.putParam('with_price', with_price);
    if (time_close != null)
        req.putParam('time_close', time_close);
    if (lock != null)
        req.putParam('lock', lock);

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return true;
};

export const docsToXSLX: (fromDate: Date, toDate: Date, dtype?: DocumentType, pdf?: boolean, specificEntId?: number) => Promise<any> = async (fromDate, toDate, dtype, pdf, specificEntId) => {
    const req: ApiCall = new ApiCall('CALCULATE_DOCUMENTS_SUM');
    req.putParam('date_range', `${dateObjectToString(fromDate)}..${dateObjectToString(toDate)}`);
    if (dtype)
        req.putParam('doc_type', documentTypes[dtype].nkType);
    if (pdf) {
        req.putParam('pdf', pdf);
    }


    if (specificEntId) {
        req.putParam('ent_id', specificEntId);
    }

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return (result.first)!;
};

export const apiXSLX: (fromDate: Date, toDate: Date) => Promise<any> = async (fromDate, toDate) => {
    const req: ApiCall = new ApiCall('CALCULATE_API_EXCEL_zip');
    req.putParam('date_start', fromDate);
    req.putParam('date_end', toDate);

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return (result.first)!;
};

export const documentsZip: (fromDate: Date, toDate: Date, dtype: DocumentType) => Promise<any> = async (fromDate, toDate, dtype) => {
    const req: ApiCall = new ApiCall('CALCULATE_document_zip');


    req.putParam('doc_type', documentTypes[dtype].nkType);
    req.putParam('date_range', `${dateObjectToString(fromDate)}..${dateObjectToString(toDate)}`);

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return (result.first)!;
};

export const clientsXlsx: (ids: number[]) => Promise<any> = async (ids) => {
    const req: ApiCall = new ApiCall('CLIENTS_XLSX');

    req.putParam('clients', NKTypeConvertor().toKotlinList(ids));

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return (result.first)!;
};
export const productsXlsx: (ids: number[]) => Promise<any> = async (ids) => {
    const req: ApiCall = new ApiCall('PRODUCTS_XLSX');

    req.putParam('products', NKTypeConvertor().toKotlinList(ids));

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return (result.first)!;
};
export const clientsDebtsXLSX: (date: Date, agentId?: number) => Promise<any> = async (date, agentId) => {
    const req: ApiCall = new ApiCall('CALCULATE_client_debts');

    if (agentId)
        req.putParam('agent', agentId);


    req.putParam('date_range', dateObjectToString(date));

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // bytearray
    return (result.first)!;
};

export const fetchMimshakClient: (date?: Date,f?:any ) => Promise<any> = async (date,f) => {
    let req: ApiCall = new ApiCall('READ_MIMSHAK');

    if(date)
    req.putParam('to_date', dateObjectToString(date));

    let result = await req.execute();

    if (result == null || result.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    req = new ApiCall('READ_MIMSHAK');

    if(date)
        req.putParam('to_date', dateObjectToString(date));

    result = await req.execute();

    if (result == null || result.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    if(f)
        f()
    // bytearray
    return true;
};


export const getFile = async (print: boolean, func: () => Promise<any>, title, type?: string, callback?: () => void, setLoader?: (d) => void, email?: (b, t) => Promise<boolean>) => {
    try {
        if (setLoader) {
            setLoader(true);
        }
        const byteArray = await func();
        if (email) {
            await email(byteArray, title)
        } else {
            if (print)
                printPdf(byteArray);
            else
                saveByteArray(byteArray, title, type);

        }

        if (callback)
            callback()

        if (setLoader) {
            setLoader(false);
        }
    } catch (e) {
        Swal.fire({
            title: 'שגיאה בגישה לנתונים',
            target: '#custom-target',
            text: '',
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#d63030'
        });
        setLoader?.call(false)

    }


};

export function readFile(file) {
    return new Promise((resolve, reject) => {
        // Create file reader
        let reader = new FileReader()

        // Register event listeners
        reader.addEventListener("loadend", e => resolve(e.target.result))
        reader.addEventListener("error", reject)

        // Read file
        reader.readAsArrayBuffer(file)
    })
}

export async function getAsByteArray(file) {
    return new Int8Array(await readFile(file))
}

export type LoadXlsxExtras = {
    /** false = do not update duplicates (skip / fail rows for existing entities per server logic). */
    update?: boolean;
    ignore_must?: boolean;
};

export const load_from_xlsx: (
    f: any,
    load_type: string,
    type?: string,
    date?: Date,
    load_doc_id?: boolean,
    extras?: LoadXlsxExtras,
) => Promise<any> = async (f, load_type, type, date, load_doc_id, extras) => {
    const req: ApiCall = new ApiCall('LOAD_XLSX');

    req.putParam('f', f);
    req.putParam('load_type', load_type);
    if (type)
        req.putParam('type', type);
    if (date)
        req.putParam('date', dateObjectToString(date));
    if (load_doc_id)
        req.putParam('load_doc_id', load_doc_id);
    if (extras?.update !== undefined)
        req.putParam('update', extras.update ? 1 : 0);
    if (extras?.ignore_must)
        req.putParam('ignore_must', 1);

    const result = await req.execute();

    if (result == null || result.second.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });
    // str result
    return (result.first)!;
};

export const whatsappRefresh: (instanceId?: string) => Promise<boolean> = async (instanceId?: string) => {
    const req: ApiCall = new ApiCall('RESET_WHATSAPP_API');
    if (instanceId)
        req.putParam('instanceId', instanceId);


    const result = await req.execute();

    if (result == null || result.name !== 'SUCCESS')
        return new Promise((resolve, reject) => {
            reject(Error);
        });

    return true;
};
export const callbackNetworkResult = async (func: () => Promise<any>, callback: (result) => void,loader?:any) => {
    try {
        if(loader)
            loader(true);
        const str = await func();
        callback(str);
        if(loader)
            loader(false);
    } catch (e) {
        Swal.fire({
            title: 'שגיאה בגישה לנתונים',
            target: '#custom-target',
            text: '',
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#d63030'
        });
        if(loader)
            loader(false);

    }


};

